import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-result',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    TranslocoModule,
  ],
  templateUrl: './result.component.html',
  styleUrl: './result.component.scss'
})
export class ResultComponent {
  data = inject(MAT_DIALOG_DATA);
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  dialogRef: MatDialogRef<ResultComponent>;
  constructor(private _changeDetectorRef: ChangeDetectorRef,) {

  }

}
